import apiSportEvents from '@/api/sports-events'

const state = {
  data: [],
  isLoading: false,
  error: null
}

export const mutationTypes = {
  getSportEventsStart: '[sport events] Get sport events start',
  getSportEventsSuccess: '[sport events] Get sport events success',
  getSportEventsFailure: '[sport events] Get sport events failure'
}

export const actionTypes = {
  getSportEvents: '[sport events] Get sport events'
}

const mutations = {
  [mutationTypes.getSportEventsStart](state) {
    state.isLoading = true
    state.error = null
    state.data = []
  },

  [mutationTypes.getSportEventsSuccess](state, payload) {
    state.data = payload
    state.isLoading = false
  },

  [mutationTypes.getSportEventsFailure](state, payload) {
    state.isLoading = false
    state.error = payload
  }
}

const actions = {
  [actionTypes.getSportEvents](context) {
    context.commit(mutationTypes.getSportEventsStart)
    return new Promise(resolve => {
      apiSportEvents
        .getSportEvents()
        .then(response => {
          context.commit(mutationTypes.getSportEventsSuccess, response.data)
          resolve(response.data)
        })
        .catch(error => {
          context.commit(mutationTypes.getSportEventsFailure, error)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
